// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// 🔴 REPLACE THIS VARIABLE WITH YOUR COPIED CONFIG FROM FIREBASE CONSOLE 🔴
const firebaseConfig = {
  apiKey: "AIzaSyAacCHaq3DCFg-SNGnUc20RVy1UQCvELQk",
  authDomain: "darwin-sports-bef65.firebaseapp.com",
  projectId: "darwin-sports-bef65",
  storageBucket: "darwin-sports-bef65.firebasestorage.app",
  messagingSenderId: "703238560499",
  appId: "1:703238560499:web:d090db80029b6ba57af586"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Database
export const db = getFirestore(app);
export const auth = getAuth(app);